<template>
  <div class="section section_white">
    <div class="max-width">
      <div class="demos">
        <div class="section__head">
          <h2 class="section__title" v-html="title"></h2>
          <div class="section__text">{{ text }}</div>
        </div>

        <div class="demos__grid">
          <ThemeCard
              v-for="theme in themes"
              :key="theme.title"
              :title="theme.title"
              :preview-link="theme.previewLink"
              :tag="theme.tag"
              :image="theme.image"
              :theme-link="theme.themeLink"
              :theme-name="theme.themeName"
              :hide-links="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ThemeCard from '@/components/ThemeCard.vue'

const props = defineProps({
  title: { type: String, required: true },
  text: { type: String, required: true },
  themeId: { type: String, required: true }
})

const themes = ref([])

onMounted(async () => {
  const res = await fetch('/assets/json/themes.json')
  const data = await res.json()
  const themeData = data.find(theme => theme.id === props.themeId)
  if (themeData) {
    themes.value = themeData.styles.map(style => ({
      ...style,
      themeLink: `/themes/${themeData.id}`,
      themeName: themeData.id
    }))
  }
})
</script>

<style lang="scss">
.demos {
  .section__head {
    margin: 0 0 2.5rem;
    max-width: 480px;
  }

  .section__title {
    font-size: 2.5rem;

    @include xs {
      font-size:2rem;
    }
  }

  .section__text {
    max-width: 100%;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    grid-row-gap: 3rem;

    @include xs {
      grid-template-columns: repeat(1, 1fr);

      .theme-card__about {
        min-height:30px;
        justify-content:center;
      }
    }
  }
}
</style>
